// extracted by mini-css-extract-plugin
export default {"form":"JobForm_form__UqfvX","currency":"JobForm_currency__pW+7s"};